function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgFan = function SvgFan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M448,192C448,86.135,361.865,0,256,0S64,86.135,64,192c0,96.504,71.648,176.384,164.499,189.798 l-8.092,40.473C217.427,437.177,204.229,448,189.021,448h-18.354C147.135,448,128,467.135,128,490.667v10.667 c0,5.896,4.771,10.667,10.667,10.667h234.667c5.896,0,10.667-4.771,10.667-10.667v-10.667C384,467.135,364.865,448,341.333,448 h-18.354c-15.208,0-28.406-10.823-31.385-25.729l-8.092-40.473C376.352,368.384,448,288.504,448,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M270.677,426.458c4.969,24.844,26.969,42.875,52.302,42.875h18.354 c11.76,0,21.333,9.573,21.333,21.333H149.333c0-11.76,9.573-21.333,21.333-21.333h18.354c25.333,0,47.333-18.031,52.302-42.875 l8.552-42.768c2.052,0.065,4.057,0.31,6.125,0.31c2.068,0,4.073-0.245,6.125-0.31L270.677,426.458z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6E6E6"
    },
    cx: 256,
    cy: 192,
    r: 170.667
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303C42"
    },
    d: "M397.448,201.344c-31.655-13.762-60.901-16.865-78.257-17.35c-0.609-4.805-1.668-9.439-3.285-13.853 c0.255-0.224,0.501-0.423,0.76-0.651c8.698-7.625,26.781-23.49,64.458-30.594c3.313-0.625,6.135-2.781,7.615-5.813 c1.469-3.021,1.427-6.573-0.125-9.573c-9.948-19.229-23.708-35.771-40.875-49.188c-3.771-2.938-9.063-3.01-12.906-0.167 c-27.564,20.397-44.874,44.03-54.023,58.855c-4.326-1.826-8.934-3.048-13.678-3.887c-0.064-0.35-0.107-0.663-0.173-1.021 c-2.115-11.396-6.51-35.094,5.948-70.927c1.104-3.167-0.396-6.74-2.271-9.521c-1.885-2.792-6.01-4.594-9.365-4.76 c-20.438-1.24-41.74,2.802-61.333,10.75c-4.438,1.802-7.125,6.333-6.583,11.083c3.888,34.267,15.811,61.208,24.09,76.523 c-3.786,2.885-7.18,6.185-10.24,9.827c-0.354-0.122-0.677-0.249-1.038-0.371c-10.948-3.708-33.719-11.448-58.708-40.5 c-2.198-2.552-5.458-3.802-8.823-3.688c-3.365,0.24-6.417,2.042-8.229,4.875c-11.719,18.229-19.177,38.417-22.167,60.021 c-0.656,4.74,1.927,9.333,6.313,11.24c31.555,13.71,60.871,16.883,78.26,17.379c0.611,4.794,1.669,9.418,3.283,13.823 c-0.257,0.225-0.501,0.423-0.762,0.652c-8.698,7.625-26.781,23.49-64.458,30.594c-3.313,0.625-6.135,2.781-7.615,5.813 c-1.469,3.031-1.427,6.583,0.125,9.573c9.823,18.958,23.958,35.969,40.875,49.188c1.927,1.5,4.24,2.26,6.563,2.26 c2.229,0,4.458-0.698,6.344-2.094c27.565-20.398,44.876-44.031,54.025-58.857c4.326,1.826,8.932,3.049,13.677,3.888 c0.064,0.35,0.107,0.663,0.173,1.021c2.115,11.396,6.51,35.094-5.948,70.927c-1.104,3.167,0.396,6.74,2.271,9.521 c1.885,2.792,6.01,4.594,9.365,4.76c1.74,0.115,3.49,0.229,5.271,0.229c19.26,0,38.125-3.698,56.063-10.979 c4.438-1.802,7.125-6.333,6.583-11.083c-3.888-34.267-15.811-61.208-24.09-76.523c3.786-2.885,7.18-6.185,10.24-9.827 c0.354,0.122,0.677,0.249,1.038,0.371c10.948,3.708,33.719,11.448,58.708,40.5c2.031,2.365,4.99,3.708,8.083,3.708 c0.25,0,0.49-0.01,0.74-0.021c3.365-0.24,6.417-2.042,8.229-4.875c11.719-18.229,19.177-38.417,22.167-60.021 C404.417,207.844,401.833,203.25,397.448,201.344z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#546E7A"
    },
    cx: 256,
    cy: 192,
    r: 42.667
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M287.633,163.63c-1.876,21.809-20.012,39.036-42.299,39.036 c-12.598,0-23.816-5.59-31.633-14.297c-0.104,1.216-0.367,2.387-0.367,3.63c0,23.531,19.135,42.667,42.667,42.667 s42.667-19.135,42.667-42.667C298.667,181.066,294.417,171.188,287.633,163.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M340.948,96.406c8.302,7.375,15.542,15.688,21.635,24.854 c-30.965,8.391-48.068,21.888-57.561,30.092c-1.977-2.38-4.053-4.632-6.349-6.702C306.033,132.624,319.613,113.747,340.948,96.406z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M215.667,70.563c10.656-3.563,21.625-5.677,32.781-6.344c-8.172,30.915-5.193,52.551-2.992,64.848 c-3.138,0.526-6.132,1.372-9.098,2.339C229.611,119.008,220.016,97.758,215.667,70.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M141.448,135.073c22.672,22.548,42.875,30.629,54.742,34.762c-1.078,2.9-2.117,5.822-2.77,8.901 c-14.143-0.371-37.138-2.754-62.671-12.507C132.958,155.344,136.542,144.927,141.448,135.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M171.063,287.583c-8.219-7.323-15.521-15.719-21.615-24.854c30.947-8.38,48.039-21.878,57.53-30.082 c1.977,2.38,4.053,4.632,6.349,6.702C205.967,251.375,192.389,270.251,171.063,287.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M296.333,313.438c-10.656,3.563-21.625,5.677-32.781,6.344c8.172-30.915,5.193-52.551,2.992-64.848 c3.138-0.526,6.132-1.374,9.098-2.339C282.389,264.991,291.984,286.242,296.333,313.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546E7A"
    },
    d: "M370.552,248.927c-22.672-22.548-42.876-30.629-54.742-34.762c1.078-2.9,2.116-5.82,2.768-8.898 c14.104,0.372,37.102,2.742,62.672,12.504C379.042,228.656,375.458,239.073,370.552,248.927z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.6739,
    y1: 627.8154,
    x2: -30.5236,
    y2: 622.6641,
    gradientTransform: "matrix(21.3333 0 0 -21.3333 996.3334 13791.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M341.333,469.333h-18.354c-25.333,0-47.333-18.031-52.302-42.875l-8.552-42.768 c-2.052,0.065-4.057,0.31-6.125,0.31c-2.068,0-4.073-0.245-6.125-0.31l-8.552,42.768c-1.13,5.651-3.241,10.887-5.973,15.701 l48.508,48.508h78.809C362.667,478.906,353.094,469.333,341.333,469.333z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -38.2852,
    y1: 641.1065,
    x2: -29.0284,
    y2: 631.8508,
    gradientTransform: "matrix(21.3333 0 0 -21.3333 996.3334 13791.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M266.958,128.104c0.066,0.358,0.109,0.671,0.173,1.021c4.745,0.839,9.353,2.061,13.678,3.887 c6.626-10.736,17.698-26.105,33.676-41.505l-43.85-43.85c1.875,2.781,3.375,6.354,2.271,9.521 C260.448,93.01,264.844,116.708,266.958,128.104z M421.35,150.497l-39.322-39.32h-0.656c2.576,3.993,5.038,8.072,7.242,12.333 c1.552,3,1.594,6.552,0.125,9.573c-1.479,3.031-4.302,5.188-7.615,5.813c-37.677,7.104-55.76,22.969-64.458,30.594 c-0.259,0.228-0.505,0.427-0.76,0.651c1.617,4.414,2.676,9.048,3.285,13.853c17.355,0.486,46.602,3.589,78.257,17.35 c4.385,1.906,6.969,6.5,6.313,11.24c-2.99,21.604-10.448,41.792-22.167,60.021c-1.813,2.833-4.865,4.635-8.229,4.875 c-0.25,0.01-0.49,0.021-0.74,0.021c-3.094,0-6.052-1.344-8.083-3.708c-24.99-29.052-47.76-36.792-58.708-40.5 c-0.361-0.122-0.684-0.249-1.038-0.371c-3.06,3.642-6.453,6.941-10.24,9.827c8.279,15.315,20.202,42.257,24.09,76.523 c0.542,4.75-2.146,9.281-6.583,11.083c-17.938,7.281-36.802,10.979-56.063,10.979c-1.781,0-3.531-0.115-5.271-0.229 c-3.354-0.167-7.479-1.969-9.365-4.76c-1.875-2.781-3.375-6.354-2.271-9.521c12.458-35.833,8.063-59.531,5.948-70.927 c-0.066-0.358-0.109-0.671-0.173-1.021c-4.745-0.839-9.352-2.063-13.677-3.888c-9.148,14.826-26.46,38.458-54.025,58.857 c-1.885,1.396-4.115,2.094-6.344,2.094l46.016,46.016c12.599,2.975,25.668,4.714,39.161,4.714 c94.104,0,170.667-76.563,170.667-170.667C426.667,177.664,424.695,163.811,421.35,150.497z M196.095,213.858 c-1.613-4.405-2.672-9.029-3.283-13.823c-17.389-0.496-46.706-3.669-78.26-17.379c-0.658-0.285-1.184-0.737-1.755-1.135 l52.773,52.773c15.237-7.048,24.332-15.022,29.763-19.784C195.594,214.281,195.839,214.083,196.095,213.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.3317,
    y1: 638.1291,
    x2: -25.6507,
    y2: 629.4218,
    gradientTransform: "matrix(21.3333 0 0 -21.3333 996.3334 13791.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M448,192C448,86.135,361.865,0,256,0S64,86.135,64,192 c0,96.504,71.648,176.384,164.499,189.798l-8.092,40.473C217.427,437.177,204.229,448,189.021,448h-18.354 C147.135,448,128,467.135,128,490.667v10.667c0,5.896,4.771,10.667,10.667,10.667h234.667c5.896,0,10.667-4.771,10.667-10.667 v-10.667C384,467.135,364.865,448,341.333,448h-18.354c-15.208,0-28.406-10.823-31.385-25.729l-8.092-40.473 C376.352,368.384,448,288.504,448,192z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fan.8df4f800.svg";
export { ForwardRef as ReactComponent };